<template>
  <div
    class="vue-loop-scroll-box vue-loop-scroll"
    :class="direction == 'left' ? 'left' : ''"
    @mouseenter="stopScroll"
    @mouseleave="leaveScroll"
  >
    <ul class="vue-loop-scroll-item1">
      <slot />
    </ul>
    <ul class="vue-loop-scroll-item2" />
  </div>
</template>

<script>
export function getIndex () {
  const vue_loop_scroll_box_list = document.getElementsByClassName('vue-loop-scroll-box')
  return vue_loop_scroll_box_list.length || 0
}
export default {
  name: 'VueLoopScroll',
  props: {
    direction: { type: String, default: 'left' },
    speed: { type: Number, default: 50 },
    mouseStop: { type: Boolean, default: false },
    index: { type: Number, default: 0 }
  },
  data () {
    return {
      isRun: false,
      runTime: null
    }
  },
  watch: {},
  mounted () {
    // this.startScroll()
  },
  updated () {
    this.stopScroll(true)
    setTimeout(this.leaveScroll(true), 300)
  },
  methods: {
    //开始滚动
    startScroll () {
      this.$nextTick((res) => {
        var sbox = document.getElementsByClassName('vue-loop-scroll-box')[this.index]
        var sitem1 = document.getElementsByClassName('vue-loop-scroll-item1')[this.index]
        var sitem2 = document.getElementsByClassName('vue-loop-scroll-item2')[this.index]
        // sitem2.innerHTML = sitem1.innerHTML
        const width = sitem1.offsetWidth
        // console.log('sitem1.offsetWidth',width)
        // console.log('sbox.scrollLeft',sbox.scrollLeft)
        var that = this
        this.timer1 = setInterval(function () {
          // console.log('')
          if (that.direction == 'up') {
            that.scrollUp(sbox, sitem1)
          }
          if (that.direction == 'left') {
            that.scrollLeft(sbox, width)
          }
        }, this.speed)
      })
    },
    //向左滚动
    scrollLeft (sbox, width) {
      if (sbox.scrollLeft >= width - 345) {
        // console.log('sbox.scrollLeft3',sbox.scrollLeft,'width:',width,width-345)
        if (width - 345 < 0) this.stopScroll(true)
        sbox.scrollLeft = 0
      } else {
        // console.log('sbox.scrollLeft1',sbox.scrollLeft)
        sbox.scrollLeft++
        // console.log('sbox.scrollLeft2',sbox.scrollLeft)
      }
    },
    //向上滚动
    scrollUp (sbox, sitem1) {
      if (sbox.scrollTop >= sitem1.offsetHeight) {
        sbox.scrollTop = 0
      } else {
        sbox.scrollTop++
      }
    },
    //鼠标移入停止
    stopScroll (type = false) {
      if (this.mouseStop || type) {
        clearInterval(this.timer1)
      }
    },
    //鼠标移开
    leaveScroll (type = false) {
      if (this.mouseStop || type) {
        this.startScroll()
      }
    }
  }
}
</script>

<style lang="scss">
.vue-loop-scroll {
  height: 50px;
  overflow: hidden;
  ul {
    li {
      height: 50px;
      overflow: hidden;
    }
  }
  &.left {
    white-space: nowrap;
    ul {
      display: inline-block;
      li {
        display: inline-block;
        padding: 0 12px;
      }
    }
  }
}
</style>
